import { render, staticRenderFns } from "./TournamentView.vue?vue&type=template&id=5c52dacb&scoped=true&"
import script from "./TournamentView.vue?vue&type=script&lang=js&"
export * from "./TournamentView.vue?vue&type=script&lang=js&"
import style0 from "./TournamentView.vue?vue&type=style&index=0&id=5c52dacb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c52dacb",
  null
  
)

export default component.exports